"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreBaseModule = exports.MODULE_NAME_CORE = void 0;
const helpers_1 = require("../helpers");
const messages_1 = require("./messages");
exports.MODULE_NAME_CORE = 'core';
__exportStar(require("./messages"), exports);
__exportStar(require("./options"), exports);
__exportStar(require("./types"), exports);
class CoreBaseModule {
    constructor(defaultOptions, ...options) {
        this.loaded = false;
        this.defaultOptions = defaultOptions;
        this.options = (0, helpers_1.mergeDeepWithDefault)(this.defaultOptions, ...options);
    }
    getOptions() {
        return this.options;
    }
    /**
     * with this method, you overwrite the options using default as base
     * @param options
     */
    setOptions(options) {
        this.options = (0, helpers_1.mergeDeepWithDefault)(this.defaultOptions, options);
    }
    validateLoaded() {
        if (!this.loaded) {
            throw Error(messages_1.CoreMessages.CORE_MODULE_NOT_LOADED + ': ' + this.constructor.name);
        }
    }
}
exports.CoreBaseModule = CoreBaseModule;
//# sourceMappingURL=index.js.map